module.exports = __webpack_public_path__ + "static/media/test6_1.4acf0eaa.png";